module.exports = __webpack_public_path__ + "static/img/detail-textbg.2b27fe30.png";